import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Footer = ({ siteTitle }) => (
  // <header style={{background: `rebeccapurple`, marginBottom: `1.45rem`,}}>
  //   <div style={{margin: `0 auto`, maxWidth: 960, padding: `1.45rem 1.0875rem`,}}>
  //     <h1 style={{ margin: 0 }}>
  //       <Link to="/" style={{ color: `white`, textDecoration: `none`, }} >
  //         {siteTitle}
  //       </Link>
  //     </h1>
  //   </div>
  // </header>
  <footer class="footer">
    <div class="content has-text-centered">
      <p class="paragraph-footer">
        Fjarðargata 13-15 - 220 Hafnarfjörður - Kt: 460295-2389 - S: 575 5640<br></br>
        strendingur@strendingur.is - vsk.nr: 45579 - Fyrirtækið er skráð hjá Hlutafélagaskrá - 
        <span class="footer-link"> 
          <a href="http://maps.google.is/maps?q=13-15+Fjar%C3%B0argata,+Hafnarfj%C3%B6r%C3%B0ur,+H%C3%B6fu%C3%B0borgarsv%C3%A6%C3%B0i&hl=en&ie=UTF8&sll=64.070698,-21.96476&sspn=0.120098,0.214233&vpsrc=0&safe=high&hnear=Fjar%C3%B0argata,+Hafnarfjordur&t=h&z=15" target="_blank"> Staðsetning/Kartplassering/Location</a>
        </span>
      </p>
    </div>
  </footer>    
)

/*
Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}
*/
export default Footer
